// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__hLy4C","btnSearch":"styles_btnSearch__1DkDs"};